








































































import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import { RouteRegEx } from '@/types/enums';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import { LockService } from '@/services/LockService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { LockMaintenanceModel, LockSearchModel, LockApplicationType, LockModel, LockTypeModel } from '@/types';
import { ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper } from '@/mixins';
import moment from 'moment';
moment.locale(navigator.language);

import InfoTooltip from '@/components/shared/InfoTooltip.vue';

export default Vue.extend({
  name: 'LockMaintenance',
  mixins: [ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper],
  data() {
    return {
      isLoading: false,
      pageIsLoading: false,
      lockMaintenanceModel: [] as LockMaintenanceModel[],
      lockSearchModel: {
        applicationType: '',
        lockTypeId: 0,
        showPersistentLocks: false
      } as LockSearchModel,
      fields: [
        {
          key: 'actions',
          label: '',
          sortable: false
        },
        {
          key: 'id',
          label: 'Lock Id',
          sortable: true
        },
        {
          key: 'isLockedOnDesktop',
          label: 'Lock Application',
          sortable: true,
          formatter: (value: any) => {
            return LockApplicationType[1 - value];
          }
        },
        {
          key: 'lockedByUser.username',
          label: 'Lock Owner',
          sortable: true
        },
        {
          key: 'lockType',
          label: 'Lock Type',
          sortable: true
        },
        {
          key: 'itemId',
          label: 'Item Id',
          sortable: true
        },
        {
          key: 'createdDate',
          label: 'Created Date',
          formatter: 'date',
          sortable: true
        },
        {
          key: 'workstation',
          label: 'Workstation',
          sortable: true
        },
        {
          key: 'isPersistentLock',
          label: 'Persistent Lock',
          sortable: true,
          formatter: (value: any) => {
            if (value === false) {
              return 'No';
            } else {
              return 'Yes';
            }
          }
        },
        {
          key: 'lockMessage',
          label: 'Lock Message',
          sortable: true
        },
        {
          key: 'expires',
          label: 'Expires',
          sortable: true,
          formatter: (value: any) => {
            if (value == null || moment(value).isValid() === false) {
              return 'Never';
            } else if (moment(value).isSameOrBefore(moment())) {
              return 'Expired';
            } else {
              return moment(value)
                .locale(navigator.language)
                .format('L LT');
            }
          }
        },
        {
          key: 'sessionId',
          label: 'Session',
          sortable: true
        }
      ],
      hasError: false,
      errorMessage: '',
      tableStateKey: MTablehelper.Constants.TableStoreKeys.LockMaintenance
    };
  },
  methods: {
    async getLocksAsync(this: any) {
      try {
        this.isLoading = true;
        this.lockMaintenanceModel = await LockService.getLocksAsync(this.lockSearchModel);
      } catch (error) {
        this.$log('Failed to get locks', error);
      } finally {
        this.isLoading = false;
      }
    },
    isPersistentLock(row: any) {
      return row.item.isPersistentLock;
    },
    async onReleaseLockAsync(this: any, row: any) {
      try {
        let confirmed = true;
        if (this.isPersistentLock(row) === true) {
          confirmed = await this.showConfirmationModalAsync(
            this.$bvModal,
            'Are you sure you want to remove this persistent lock?'
          );
        }
        if (confirmed) {
          await LockService.releaseAnyUsersLockAsync(row.item.id).then(() => {
            SnotifyConfiguration.showSuccess('Lock removed successfully.');
            this.getLocksAsync();
          });
        }
      } catch (error) {
        this.$log('failed to remove lock', error);
      }
    },
    resetViewState(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.LockMaintenance);
      if (!canKeepState) {
        this.resetMTableState(this.tableStateKey);
      }
    },
    lockTypeChanged(value: any) {
      this.lockSearchModel.lockTypeId = value;
      this.getLocksAsync();
    },
    applicationTypeChanged(value: any) {
      this.lockSearchModel.applicationType = value;
      this.tidyUpListValues();
      this.getLocksAsync();
    },
    tidyUpListValues() {
      if (Number(this.lockSearchModel.applicationType) === 0) {
        this.lockSearchModel.applicationType = 'All';
      }
    },
    async initialise(this: any) {
      try {
        this.pageIsLoading = true;
        this.resetViewState();
        await this.getLocksAsync();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.pageIsLoading = false;
      }
    }
  },
  computed: {
    gridLocks(this: any) {
      if (this.lockMaintenanceModel != null && this.lockMaintenanceModel.locks != null) {
        return this.lockMaintenanceModel.locks;
      } else {
        return [] as LockModel[];
      }
    },
    selectedLockType: {
      get(this: any) {
        if (
          this.lockSearchModel.lockTypeId != null &&
          this.lockMaintenanceModel?.lockTypes?.find(
            (x: LockTypeModel) => x.entityId === this.lockSearchModel.lockTypeId
          ) !== undefined
        ) {
          return this.lockSearchModel.lockTypeId;
        } else {
          this.lockSearchModel.lockTypeId = null;
          return this.lockSearchModel.lockTypeId;
        }
      },
      set(this: any, value: any) {
        this.lockSearchModel.lockTypeId = value;
      }
    },
    selectedApplicationType: {
      get(this: any) {
        if (
          this.lockSearchModel.applicationType != null &&
          this.lockMaintenanceModel?.applicationTypes?.find(
            (x: string) => x === this.lockSearchModel.applicationType
          ) !== undefined
        ) {
          return this.lockSearchModel.applicationType;
        } else {
          this.lockSearchModel.applicationType = null;
          return this.lockSearchModel.applicationType;
        }
      },
      set(this: any, value: any) {
        this.lockSearchModel.applicationType = value;
      }
    }
  },
  watch: {
    'lockSearchModel.showPersistentLocks'() {
      this.getLocksAsync();
    }
  },
  async mounted() {
    this.initialise();
  },
  components: {
    MStoreTable,
    MStoreFormSelect,
    LoadingSpinner,
    InfoTooltip,
    MStoreSpinnerButton
  }
});
